import {takeEvery} from 'redux-saga/effects'
import {
  CREATE_EXAM_REPORT_CARD_WORD_TEMPLATE,
  DELETE_EXAM_REPORT_CARD_WORD_TEMPLATE,
  GET_EXAM_REPORT_CARD_WORD_TEMPLATE,
  GET_EXAM_REPORT_CARD_WORD_TEMPLATES,
  GET_WORD_TEMPLATE_FORM_SETTINGS,
  UPDATE_EXAM_REPORT_CARD_WORD_TEMPLATE,
} from 'setup/redux/Actions/ExamReportCardWordTemplate/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_EXAM_REPORT_CARD_WORD_TEMPLATES, fetchData)
  yield takeEvery(CREATE_EXAM_REPORT_CARD_WORD_TEMPLATE, fetchData)
  yield takeEvery(GET_WORD_TEMPLATE_FORM_SETTINGS, fetchData)
  yield takeEvery(GET_EXAM_REPORT_CARD_WORD_TEMPLATE, fetchData)
  yield takeEvery(UPDATE_EXAM_REPORT_CARD_WORD_TEMPLATE, fetchData)
  yield takeEvery(DELETE_EXAM_REPORT_CARD_WORD_TEMPLATE, fetchData)
}

export default dataSaga
